import { combineReducers } from 'redux';
import { reducerImportThemeAtomToClientServiceNPageInThemeClient } from './importThemeAtomToClientService/reducer';
import { reducerSyncShopifyNClonePageAtomServiceToThemeAtomService } from './syncShopifyNClonePageAtomServiceToThemeAtomService/reducer';

export const reducersSocket = combineReducers({
  importThemeAtomToClientService: reducerImportThemeAtomToClientServiceNPageInThemeClient,
  syncShopifyNClonePageAtomServiceToThemeAtomService: reducerSyncShopifyNClonePageAtomServiceToThemeAtomService,
});
